export const emergencyTypeMap = {
  1: {'val': '緊急', dispOrder: 1},
  // 2: {'val': '映像要求', dispOrder: 2},
  // 0: {'val': 'その他', dispOrder: 3},
  3: {'val': 'A', dispOrder: 4},
};

export const emergencyTypes = Object.entries(emergencyTypeMap).map(e => {
  return { key: parseInt(e[0]), val: e[1].val };
});
